// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-collapse--collapsed{display:none!important;height:0}.v-collapse-enter-active,.v-collapse-leave-active{transition:height .35s ease;overflow:hidden}@media(prefers-reduced-motion:reduce){.v-collapse-enter-active,.v-collapse-leave-active{transition:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
